var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.info ? _c("div", [_vm.info.policyInfo.reviewNodeStatus == 6 ? _c("a-alert", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      description: _vm.$t("拒绝赔付理由") + ":" + _vm.info.policyInfo.rejectOpinion,
      type: "error"
    }
  }) : _vm._e(), _vm.info.policyInfo && _vm.info.policyInfo.auditOpinion && _vm.info.policyInfo.reviewNodeStatus != 6 ? _c("a-alert", {
    attrs: {
      type: "error",
      message: _vm.$t("拒绝理由") + "-" + _vm.info.policyInfo.auditOpinion,
      banner: ""
    }
  }) : _vm._e(), _vm.info.policyInfo && _vm.info.policyInfo.auditOpinion && _vm.info.policyInfo.reviewNodeStatus == 6 ? _c("a-alert", {
    attrs: {
      type: "error",
      message: _vm.$t("备注") + "-" + _vm.info.policyInfo.auditOpinion,
      banner: ""
    }
  }) : _vm._e(), _c("information", {
    attrs: {
      policyInfo: _vm.info.policyInfo
    }
  }), _c("claims-info", {
    attrs: {
      claimsInfo: _vm.info.claimsInfo,
      policyNo: _vm.info.policyInfo.policyNo,
      status: _vm.info.policyInfo.reviewNodeStatus,
      type: "examine",
      examine: _vm.$route.params.type == 1 ? false : true,
      nodeId: String(_vm.$route.params.nodeid)
    },
    on: {
      back: function ($event) {
        return _vm.$router.go(-1);
      }
    }
  })], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };